import { render, staticRenderFns } from "./officialAccount.vue?vue&type=template&id=463e3a2e&scoped=true&"
import script from "./officialAccount.vue?vue&type=script&lang=js&"
export * from "./officialAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e3a2e",
  null
  
)

export default component.exports